import { Swiper } from '@services';
import { N as Navigation } from './navigation-Bm_wcxKy.js';
import './create-element-if-not-defined-CdtEf1Zs.js';
import './utils-BgX2tuHA.js';

class ShopTheLook extends HTMLElement {
  swiperContainer = this.querySelector('.swiper');
  nextButton = this.querySelector('.swiper-button-next');
  prevButton = this.querySelector('.swiper-button-prev');

  connectedCallback() {
    if (!this.swiperContainer) return;

    this.initSwiper();
  }

  /**
   * Initializes the swiper instance
   */
  initSwiper() {
    const slideCount = this.swiperContainer.querySelectorAll('.swiper-slide').length;

    this.swiperInstance = new Swiper(this.swiperContainer, {
      modules: [Navigation],
      slidesPerView: slideCount > 2 ? 1.4 : 2,
      spaceBetween: 1,
      loop: true,
      navigation: {
        nextEl: this.nextButton,
        prevEl: this.prevButton,
      },
      breakpoints: {
        768: {
          slidesPerView: slideCount > 4 ? 3.2 : 4,
        },
        1024: {
          slidesPerView: slideCount > 4 ? 3.6 : 4,
        },
      },
    });
  }
}

customElements.define('shop-the-look', ShopTheLook);
